import { computed } from 'vue';
import { useFlowStore } from '@/stores/useFlowStore';

// The API only sends extra_night_pricing for arrangements with the mode enabled.
export function useExtraNightPricing() {
	const flowStore = useFlowStore();

	const lines = computed(() => flowStore.checkout.meta?.extra_night_pricing?.lines ?? []);

	const isEnabled = computed(() => flowStore.checkout.meta?.extra_night_pricing !== undefined);

	const hasStay = computed(() => {
		const arrival = flowStore.checkout.data?.arrival?.date;
		const departure = flowStore.checkout.data?.departure?.date;

		return !!arrival && !!departure && departure > arrival;
	});

	// A single night needs no breakdown: the arrangement line already is that one night.
	const hasBreakdown = computed(() => hasStay.value && lines.value.some((line) => line.is_extra_night));

	return { lines, isEnabled, hasStay, hasBreakdown };
}
